import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Chart } from '../../../../helpers/chart.js';
import { fetchJson } from '../../../../helpers';
import { useSelector } from 'react-redux';
import { useChartResize } from '../../hooks/useChartResize.js';
import { DEFAULT_COLORS } from '../base/constants.js';
import NoDataComponent from '../../no_data_component.jsx';

import {
    monitoring_dashboard_call_status_data_path
} from '~/routes';
import LoadingIndicator from '../../../common/loading_indicator';

function CallProgressWidget({ widgetId }) {
    const callStatusChartRef = useRef();
    const [chart, setChart] = useState();
    const [loading, setLoading] = useState(false);
    const [chartData, setChartData] = useState(null);
    const call_id = useSelector(state => state.dashboard.widgets[widgetId].settings?.call_id);
    const submit_color = useSelector(state => state.dashboard.widgets[widgetId].settings?.submit_color);
    const draft_color = useSelector(state => state.dashboard.widgets[widgetId].settings?.draft_color);
    const drop_color = useSelector(state => state.dashboard.widgets[widgetId].settings?.drop_color);
    const legend_text_color = useSelector(state => state.dashboard.widgets[widgetId].settings?.legend_text_color);


    const initChart = useCallback(() => {
        if (chart) chart.destroy();
        if (!callStatusChartRef.current || !chartData) return;
        const barsDataWithColors = {
            ...chartData.bars,
            datasets: chartData.bars.datasets.map((d, i) => {
            return {
                ...d, 
                backgroundColor: [submit_color, draft_color, drop_color][i] || DEFAULT_COLORS[i]
            }
            })
        }
        setChart(new Chart(callStatusChartRef.current, {
            type: "bar",
            data: barsDataWithColors,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                x:
                    {
                    stacked: true,
                    ticks: {
                        autoSkip: false,
                        maxRotation: 0,
                        padding: 10,
                        // callback: function (value, index, values) {
                        // return value.split(" ");
                        // },
                    },
                    },
                y:
                    {
                    ticks: {
                        beginAtZero: true,
                        // callback: function (value, index, values) {
                        // return Number.isInteger(value) ? value : "";
                        // },
                    },
                    stacked: true,
                    },
                },
                tooltips: {
                mode: "index",
                callbacks: {
                    label: function (tooltipItem, data) {
                    var label = data.datasets[tooltipItem.datasetIndex].label;
                    if (
                        data.datasets[tooltipItem.datasetIndex].optional[tooltipItem.index] ===
                        "ProjectCallForm"
                    ) {
                        switch (tooltipItem.datasetIndex) {
                        case 0:
                            label = I18n.t("submitted");
                            break;
                        case 1:
                            label = I18n.t("draft");
                            break;
                        case 2:
                            label = null;
                        default:
                            break;
                        }
                    } else {
                        switch (tooltipItem.datasetIndex) {
                        case 0:
                            label = I18n.t("approved");
                            break;
                        case 1:
                            label = I18n.t("unprocessed");
                            break;
                        default:
                            break;
                        }
                    }
                    if (label) {
                        label += ": ";
                    }
                    label += Math.round(tooltipItem.yLabel * 100) / 100;
                    return label;
                    },
                },
                },
                legend: {
                labels: {
                    color: legend_text_color,
                },
                },
            },
            }))
    }, [chartData, submit_color, draft_color, drop_color, legend_text_color])

    const handleResize = useChartResize(callStatusChartRef, initChart);

    const loadData = (callId) => {
        if (chart) chart.destroy();
        setLoading(true);
        fetchJson(monitoring_dashboard_call_status_data_path({ call_id: callId })).then((res) => {
            setLoading(false);
            setChartData(res);
        });
    }

    useEffect(() => {
        return () => {
            if (chart) chart.destroy();
        }
    }, [])

    useEffect(() => {
        if (call_id){
            loadData(call_id)
        }
    }, [call_id])

    useEffect(() => {
        if (!loading && chartData){
            handleResize();
        }
    }, [chartData, submit_color, draft_color, drop_color, legend_text_color])

    return (
      loading ? <LoadingIndicator /> :
      (
        call_id ? 
            <div className="chart-container-gen2">
                <canvas ref={callStatusChartRef} />
            </div>
        : <NoDataComponent />
      )
    )
}

export default CallProgressWidget;
